export const countryCodeToEmoji = (code) => {
  if (!code || typeof code !== 'string') return '🌍';
  
  const cleanCode = code.trim().toUpperCase();
  
  if (/[\u{1F1E6}-\u{1F1FF}]{2}/u.test(cleanCode) || cleanCode.startsWith('🇫') || cleanCode.startsWith('🇯')) {
    return cleanCode;
  }
  
  const countryCode = cleanCode.substring(0, 2);
  
  if (countryCode.length < 2) return '🌍';
  
  const codePoints = countryCode
    .split('')
    .map(char => 127397 + char.charCodeAt());
  
  try {
    return String.fromCodePoint(...codePoints);
  } catch {
    return '🌍';
  }
};

export const countryNameToCode = (name) => {
  if (!name || typeof name !== 'string') return null;
  
  const cleanName = name.trim().toLowerCase();
  
  if (/^[a-z]{2}$/i.test(cleanName)) {
    return cleanName.substring(0, 2).toUpperCase();
  }
  
  const countryMap = {
    'украина': 'UA', 'укр': 'UA', 'україна': 'UA', 'ukraine': 'UA', 'ua': 'UA', 'ukr': 'UA',
    'финляндия': 'FI', 'фин': 'FI', 'suomi': 'FI', 'finland': 'FI', 'fi': 'FI',
    'япония': 'JP', 'япон': 'JP', 'nihon': 'JP', 'japan': 'JP', 'jp': 'JP', 'jpn': 'JP',
    'сша': 'US', 'соединенные штаты': 'US', 'соединённые штаты': 'US', 'америка': 'US', 'usa': 'US', 'united states': 'US', 'us': 'US',
    'германия': 'DE', 'герм': 'DE', 'deutschland': 'DE', 'germany': 'DE', 'de': 'DE',
    'великобритания': 'GB', 'англия': 'GB', 'англи': 'GB', 'uk': 'GB', 'united kingdom': 'GB', 'gb': 'GB', 'england': 'GB',
    'франция': 'FR', 'фран': 'FR', 'france': 'FR', 'fr': 'FR',
    'нидерланды': 'NL', 'нидерл': 'NL', 'netherlands': 'NL', 'nl': 'NL', 'holland': 'NL',
    'швеция': 'SE', 'швец': 'SE', 'sverige': 'SE', 'sweden': 'SE', 'se': 'SE',
    'швейцария': 'CH', 'швейц': 'CH', 'schweiz': 'CH', 'switzerland': 'CH', 'ch': 'CH',
    'австралия': 'AU', 'австр': 'AU', 'australia': 'AU', 'au': 'AU',
    'канада': 'CA', 'канад': 'CA', 'canada': 'CA', 'ca': 'CA',
    'бразилия': 'BR', 'бразил': 'BR', 'brasil': 'BR', 'brazil': 'BR', 'br': 'BR',
    'россия': 'RU', 'росс': 'RU', 'russia': 'RU', 'ru': 'RU',
    'индия': 'IN', 'индий': 'IN', 'india': 'IN', 'in': 'IN',
    'китай': 'CN', 'кита': 'CN', 'china': 'CN', 'cn': 'CN',
    'южная корея': 'KR', 'корея': 'KR', 'korea': 'KR', 'south korea': 'KR', 'kr': 'KR',
    'сингапур': 'SG', 'сингап': 'SG', 'singapore': 'SG', 'sg': 'SG',
    'турция': 'TR', 'турец': 'TR', 'turkey': 'TR', 'tr': 'TR',
    'мексика': 'MX', 'мексик': 'MX', 'mexico': 'MX', 'mx': 'MX',
    'аргентина': 'AR', 'аргент': 'AR', 'argentina': 'AR', 'ar': 'AR',
    'южная африка': 'ZA', 'африка': 'ZA', 'south africa': 'ZA', 'za': 'ZA',
    'испания': 'ES', 'испан': 'ES', 'spain': 'ES', 'es': 'ES',
    'италия': 'IT', 'итал': 'IT', 'italy': 'IT', 'it': 'IT',
    'польша': 'PL', 'польск': 'PL', 'poland': 'PL', 'pl': 'PL'
  };
  
  return countryMap[cleanName] || null;
};

export const getFlagCode = (flag) => {
  if (!flag) return 'un';
  
  const flagToCode = {
    '🇫🇮': 'fi', '🇯🇵': 'jp', '🇺🇸': 'us', '🇩🇪': 'de', '🇬🇧': 'gb',
    '🇫🇷': 'fr', '🇳🇱': 'nl', '🇸🇪': 'se', '🇨🇭': 'ch', '🇦🇺': 'au',
    '🇨🇦': 'ca', '🇧🇷': 'br', '🇷🇺': 'ru', '🇮🇳': 'in', '🇨🇳': 'cn',
    '🇰🇷': 'kr', '🇸🇬': 'sg', '🇹🇷': 'tr', '🇲🇽': 'mx', '🇦🇷': 'ar',
    '🇿🇦': 'za', '🇪🇸': 'es', '🇮🇹': 'it', '🇵🇱': 'pl', '🇺🇦': 'ua',
    '🌍': 'un'
  };
  
  return flagToCode[flag] || 'un';
};